import React from 'react';
import './Step7.css';

/**
 * Step7 — Оформлення до закладу
 *
 * Всі класи ізольовані під BEM-префіксом `s7__`
 * щоб уникнути конфліктів з Bootstrap та wizard styles.css.
 *
 * Props:
 *   formData       — загальний formData wizard (для відображення ПІБ дитини)
 *   inviteData     — { groupNumber, groupId, placeType, periodStartYear }
 *   acceptData     — { number, smallNumber }
 *   errors         — { number?, smallNumber? }
 *   onAcceptChange — (field, value) => void
 */

const placeTypeLabels = {
 standart:    'Звичайне місце',
  inclusive: 'Інклюзивне місце',
  special:   'Спеціальне місце',
  sanatory:  'Санаторне місце',
};

const Field = ({ label, required, error, children }) => (
  <div className="s7__field">
    <label className="s7__label">
      {label}
      {required && <span className="s7__required"> *</span>}
    </label>
    {children}
    {error && <div className="s7__error">{error}</div>}
  </div>
);

const ReadonlyInput = ({ value }) => (
  <input
    type="text"
    className="s7__input s7__input--readonly"
    value={value}
    readOnly
    disabled
  />
);

const Step7 = ({ formData, inviteData = {}, acceptData = {}, errors = {}, onAcceptChange }) => {

  const { groupNumber = '', placeType = '', periodStartYear = '' } = inviteData;
  const { number = '', smallNumber = '' } = acceptData;

  const childName = formData?.child
    ? [formData.child.lastName, formData.child.firstName, formData.child.secondName]
        .filter(Boolean)
        .join(' ')
    : '';

  const placeLabel = placeTypeLabels[placeType] || placeType || '—';

  const handleChange = (field) => (e) => {
    if (onAcceptChange) onAcceptChange(field, e.target.value);
  };

  return (
    <div className="s7">
      <h2 className="s7__title">Оформлення до закладу</h2>

      {/* Дитина */}
      <div className="s7__row s7__row--full">
        <Field label="Дитина" error={errors.childLastName}>
          <ReadonlyInput 
            value={childName}
            className={`s7__input${errors.childLastName ? ' s7__input--error' : ''}`} 
          />
          
        </Field>
      </div>

      {/* Група + навчальний рік */}
      <div className="s7__row s7__row--two">
        <Field label="Номер групи">
          <ReadonlyInput value={groupNumber} />
        </Field>
        <Field label="Навчальний рік">
          <ReadonlyInput value={periodStartYear} />
        </Field>
      </div>

      {/* Тип місця */}
      <div className="s7__row s7__row--full">
        <Field label="Тип місця">
          <ReadonlyInput value={placeLabel} />
        </Field>
      </div>

      {/* Табельний номер — одне поле згідно скріншота */}
      <div className="s7__row s7__row--full">
        <Field label="Табельний номер" required error={errors.number}>
          <input
            type="text"
            className={`s7__input${errors.number ? ' s7__input--error' : ''}`}
            placeholder="напр. 235"
            value={smallNumber}
            onChange={handleChange('smallNumber')}
          />
        </Field>
      </div>

      <div className="s7__notice">
        Після натискання <strong>«Прийняти до закладу»</strong> дитину буде зараховано
        до групи <strong>{groupNumber}</strong>.
        Переконайтесь, що табельний номер введено правильно.
      </div>
    </div>
  );
};

export default Step7;